export const PLAYER_ROUTES = [
  '/player/channel/:channelId?/:startTime?',
  '/player/vod-channel/:channelId?/:startTime?',
  '/player/vod/:videoId',
  '/player/trailer/:videoId',
  '/player/series/:seriesId/:episodeId?',
];
